<template>
    <section class="home-navigation">
        <div class="fixed fixed-lg">
            <div class="outline corner" v-for="(item, i) in navigationItems" :key="i">
                <div>
                    <i class="f0" :class="item.icon"></i>
                </div>
                <div class="text-content">
                    <h2 class="m-b-1 f3 text-bold">{{ item.title }}</h2>
                    <p>{{ item.description }}</p>
                </div>
                <a class="f5 text-bold" :href="item.href" :aria-label="'Learn more about ' + item.title">
                    {{ item.link }} <i class="m-l-1 f4 icon-arrow-right"></i>
                </a>
            </div>
        </div>
    </section>
</template>

<script src="./home-navigation.js"></script>

<style lang="scss">
@use "./home-navigation.scss" as *;
</style>